import React, { useMemo } from "react";
import { IFormTemplateJson } from "../shared/form/models";
import { IEFormsTemplate } from "csd.phoenix.models/EFormsTemplate";
import FormPartFactory from "../shared/form/dynamicForm/parts/FormPartFactory";
import FormHost from "../shared/form/FormHost";
import { FormModes } from "../shared/form/models/baseTypes";
import { CancelButtonState } from "../shared/form/models/baseTypes";
import createFormValidator from "../shared/form/dynamicForm/validations";
import { IPrefillData } from "../../stores/formsStore";


interface IProps {
  template: IEFormsTemplate;
  prefillData: IPrefillData;
  onSubmit: (values: object) => void;
  onCompleted: () => void;
};


const Form = ({ template, prefillData, onSubmit, onCompleted }: IProps) => {
  const templateJson = useMemo<IFormTemplateJson>(() => JSON.parse(template.JSONTemplateBody), [template.JSONTemplateBody]);
  const formValidator = useMemo(() => createFormValidator(templateJson), [templateJson]);

  return (
    <FormHost<IPrefillData>
      key={template.RecordId} // We want the Formik instance to be recreated when switching forms.
      formMode={FormModes.Edit}
      locale={template.UICulture}
      initialValues={prefillData}
      onSave={onSubmit}
      onFormCompleted={onCompleted}
      validate={formValidator}
      cancelButtonState={CancelButtonState.AlwaysHide}
      title={template.TemplateName}
    >
      <FormPartFactory parts={templateJson.parts} />
    </FormHost>
  );
}

export default Form;
